import { KeyboardEvent, useState } from 'react';
import { Box } from '@mui/material';
import { Icon, IconButton, Input } from '@malash-office/ui-components';

interface ChatComposerProps {
  isStreaming: boolean;
  onSend: (text: string) => void;
  onStop: () => void;
}

export const ChatComposer = ({ isStreaming, onSend, onStop }: ChatComposerProps) => {
  const [draft, setDraft] = useState('');

  const submit = () => {
    const text = draft.trim();
    if (!text || isStreaming) return;
    setDraft('');
    onSend(text);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    // Enter sends, Shift+Enter breaks the line — which is why the field is a textarea.
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
        px: 1.5,
        py: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
        flexShrink: 0
      }}
    >
      <Input
        appearance="plain"
        multiline
        maxRows={4}
        value={draft}
        onChange={event => setDraft(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="שאלו אותי משהו..."
        disabled={isStreaming}
        autoFocus
      />
      {/* While a turn is in flight the same slot stops it, so there is one control here and the
          composer never grows a second button mid-answer. */}
      {isStreaming ? (
        <IconButton shape="circle" size="medium" color="secondary" onClick={onStop} aria-label="עצירה">
          <Icon icon="close" color="inherit" size="small" />
        </IconButton>
      ) : (
        <IconButton
          shape="circle"
          size="medium"
          onClick={submit}
          disabled={!draft.trim()}
          aria-label="שליחה"
        >
          <Icon icon="arrowUpward" color="inherit" size="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default ChatComposer;
